var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.1163 12.075L15.283 10.6917C15.108 10.3834 14.9496 9.80002 14.9496 9.45835V7.35002C14.9496 4.63335 12.7413 2.41669 10.0163 2.41669C7.29129 2.41669 5.08296 4.63335 5.08296 7.35002V9.45835C5.08296 9.80002 4.92463 10.3834 4.74963 10.6834L3.90796 12.075C3.57463 12.6334 3.49963 13.25 3.70796 13.8167C3.90796 14.375 4.38296 14.8084 4.99963 15.0167C6.61629 15.5667 8.31629 15.8334 10.0163 15.8334C11.7163 15.8334 13.4163 15.5667 15.033 15.025C15.6163 14.8334 16.0663 14.3917 16.283 13.8167C16.4996 13.2417 16.4413 12.6084 16.1163 12.075Z",
    fill: "#56A012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8743 2.76669C11.2993 2.54169 10.6743 2.41669 10.016 2.41669C9.36602 2.41669 8.74102 2.53335 8.16602 2.76669C8.52435 2.09169 9.23268 1.66669 10.016 1.66669C10.8077 1.66669 11.5077 2.09169 11.8743 2.76669Z",
    fill: "#56A012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3587 16.675C12.0087 17.6417 11.0837 18.3334 10.0004 18.3334C9.34206 18.3334 8.69206 18.0667 8.23372 17.5917C7.96706 17.3417 7.76706 17.0084 7.65039 16.6667C7.75872 16.6834 7.86706 16.6917 7.98372 16.7084C8.17539 16.7334 8.37539 16.7584 8.57539 16.775C9.05039 16.8167 9.53372 16.8417 10.0171 16.8417C10.4921 16.8417 10.9671 16.8167 11.4337 16.775C11.6087 16.7584 11.7837 16.75 11.9504 16.725C12.0837 16.7084 12.2171 16.6917 12.3587 16.675Z",
    fill: "#56A012"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell-icon.083d906bceb3ec9893dbf58095a5ad73.svg";